import classNames from 'classnames'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {Link} from 'react-router-dom'
import {renderIf} from 'views/Shared'
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {BsInfoCircleFill} from "react-icons/bs";
import {GoDotFill} from "react-icons/go";
import {ItemInformation} from "../../../../components/common/ItemInformation";

const CourseClassInformation = ({ item, style, className, showDescription = true }) => {
    const t = useTranslate()
    const {
        title,
        course,
        coordinators = [],
        number_of_students,
    } = item ?? {}

    return (
        <div style={style} className={classNames('mb-3 space-y-1', className)}>
            <HeaderWithIconLine
                renderTitle={() => (
                    <div className="flex items-center gap-2">
                        <BsInfoCircleFill size={14} className="text-color-500"/>
                        <span className="font-bold text-color-300 uppercase tracking-wider">
                            {t('class information')}
                        </span>
                    </div>
                )}
            />

            <div style={{ marginLeft: 2 }} className="space-y-1">
                <ItemInformation showIcon={true} primary={true} label={t('name of class')} value={title} className=""/>
                <span className="space-x-1 text-xs italic">
                    <GoDotFill size={10} className="text-color-400" />
                    <span className="text-color-500">{`${t('belong to the course')} : `}</span>
                    <Link
                        to={getLinkToDetail(course)}
                        className="font-bold text-color-100 no-underline">
                        {getTitle(course)}
                    </Link>
                </span>
                {renderIf(
                    number_of_students,
                    <ItemInformation showIcon={true} label="number of student" value={`${number_of_students} ${t('students')}`} className="text-xs italic" />
                )}
                {renderIf(
                    coordinators?.length,
                    <div className="space-x-1 text-xs italic">
                        <GoDotFill size={10} className="text-color-400" />
                        <span className="text-color-500 whitespace-no-wrap">{`${t('coordinators')} : `}</span>
                        {coordinators.map((e, i) => {
                            const {teacher} = e ?? {}
                            return (
                                <span key={i} className="font-semibold text-color-100">
                                    {`${teacher?.prefix_title || ""} ${teacher?.fullname}`} {i < coordinators?.length - 1 && ', '}
                                </span>
                            )
                        })}
                    </div>
                )}
            </div>
        </div>
    )
}

export default CourseClassInformation
